import React from 'react';
import { BRANDING } from '../../config';

function InsightsScheduleCard() {
  const scheduleItems = [
    {
      label: 'Daily Report',
      schedule: 'Every morning at 9:00 AM ET',
      description: 'Analyzes the last 24 hours of inventory logs across all units',
    },
    {
      label: 'Weekly Report',
      schedule: 'Every Monday at 9:00 AM ET',
      description: 'Strategic intelligence report covering the full week of operations',
    },
  ];

  return (
    <div
      style={{
        background: '#f7fafc',
        border: '1px solid #e2e8f0',
        borderRadius: '8px',
        padding: '16px',
        maxWidth: '900px',
        margin: '0 auto',
      }}
    >
      <h4 style={{ margin: '0 0 12px', color: BRANDING.primaryColor }}>
        Automated Schedule
      </h4>
      {scheduleItems.map((item, i) => (
        <div
          key={i}
          style={{
            display: 'flex',
            alignItems: 'flex-start',
            gap: '12px',
            padding: '10px 0',
            borderBottom:
              i < scheduleItems.length - 1 ? '1px solid #e2e8f0' : 'none',
          }}
        >
          <div
            style={{
              width: '8px',
              height: '8px',
              borderRadius: '50%',
              background: BRANDING.primaryColor,
              marginTop: '6px',
              flexShrink: 0,
            }}
          />
          <div>
            <div style={{ fontWeight: '600', fontSize: '14px', color: '#1a202c' }}>
              {item.label}
            </div>
            <div style={{ fontSize: '13px', color: BRANDING.primaryColor, fontWeight: '500' }}>
              {item.schedule}
            </div>
            <div style={{ fontSize: '12px', color: '#718096', marginTop: '2px' }}>
              {item.description}
            </div>
          </div>
        </div>
      ))}
      <div
        style={{
          marginTop: '12px',
          fontSize: '11px',
          color: '#a0aec0',
          textAlign: 'center',
        }}
      >
        Reports are sent via email to all admin users and stored in the system
      </div>
    </div>
  );
}

export default InsightsScheduleCard;
